import { Attr, AttrMap, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";

export type UVAttr = { uv: Attr };

/**
 * Adds a UV attribute to a mesh if it doesn't already have one.
 */
export class EnsureUV<T extends AttrMap> extends IndexedMeshWriter<T | UVAttr> {

    writer: IndexedMeshWriter<T>;

    constructor(writer: IndexedMeshWriter<T>) {
        super();
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T | UVAttr> {
        const result = this.writer.computeAttributeCounts();
        if('uv' in result.attrs) {
            return result;
        } else {
            const uv = new Attr(2);
            uv.count = result.position.count;
            (result.attrs as any).uv = uv;
            return result;
        }
    }

    computeMeshData(result: IndexedMesh<T>) {
        this.writer.computeMeshData(result);
    }

}
